<script>
export default {
  props: {
    value: { type: Number, default: -1 },
    disabled: { type: Array, default: () => [] },
  },
  data() {
    return { activeTabindex: this.value };
  },
  computed: {
    firstTab() {
      if (this.value !== -1 || !this.$slots.default) return this.value;
      return this.$slots.default.findIndex((el, index) => !this.disabled.includes(index));
    },
  },
  watch: {
    value(index) {
      this.setActive(index);
    },
  },
  methods: {
    setActive(index) {
      this.activeTabindex = index;
      this.$emit('input', index);
    },
  },
  render(h) {
    if (!this.$slots.title) return h('div');
    const titles = this.$slots.title;
    const contents = (this.$slots.default || []).filter(el => el.tag);

    return h(
      'div',
      {
        class: ['sf-tabs', { pristine: this.activeTabindex === -1 }],
      },
      [
        h(
          'div',
          { class: 'sf-tabs__title' },
          titles.map((title, index) =>
            h(
              'div',
              {
                class: [
                  'sf-tabs__title__item',
                  {
                    active: index === this.activeTabindex,
                    disabled: this.disabled.includes(index),
                    first: index === this.firstTab,
                  },
                ],
                on: { click: () => this.setActive(index) },
              },
              [title]
            )
          )
        ),
        h(
          'div',
          {
            class: 'sf-tabs__content',
            on: { transitionend: () => this.$emit('change', this.activeTabindex) },
          },
          contents.map((content, index) =>
            h(
              'div',
              {
                class: [
                  'sf-tabs__content__item',
                  {
                    active: index === this.activeTabindex,
                    first: index === this.firstTab,
                  },
                ],
              },
              [
                h(
                  'div',
                  {
                    class: 'sf-tabs__content__title',
                    on: { click: () => this.setActive(-1) },
                  },
                  [this.$slots.title[index]]
                ),
                content,
              ]
            )
          )
        ),
      ]
    );
  },
};
</script>
